import styled from "@emotion/styled";
import { Box } from "@mui/material";

const HeroContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minWidth: "100%",
  maxWidth: "100%",

  [theme.breakpoints.down("md")]: {
    WebkitMaskSize: "100% 100%, 100% 50px",
    maskSize: "100% 100%, 100% 50px",
  },
}));

const BgImageContainer = styled(Box)(() => ({
  overflow: "hidden",
  position: "relative",
  width: "100%",
  height: "100%",

  WebkitMaskImage:
    "linear-gradient(to top, black 0%, black 100%), linear-gradient(to bottom, transparent 0%, black 100%)",
  WebkitMaskPosition: "center, bottom",
  WebkitMaskSize: "100% 100%, 100% 100px",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskComposite: "source-out, source-over",

  maskImage:
    "linear-gradient(to top, black 0%, black 100%), linear-gradient(to bottom, transparent 0%, black 100%)",
  maskPosition: "center, bottom",
  maskSize: "100% 100%, 100% 100px",
  maskRepeat: "no-repeat",
  maskComposite: "subtract, add",
}));

const BgImage = styled("picture")(() => ({
  display: "flex",
  position: "absolute !important",
  top: "-100px !important",
  left: "-100px !important",
  width: "100%",
  height: "100%",

  "& img": {
    objectFit: "cover",
    maxWidth: "calc(100% + 250px) !important",
    minWidth: "calc(100% + 250px) !important",
    maxHeight: "calc(100% + 250px) !important",
    minHeight: "calc(100% + 250px) !important",
  },
}));

export { HeroContainer, BgImageContainer, BgImage };
